// @ts-nocheck
import { Network } from "../../../../util"
import { User } from "../profile"

export default class EmployerAdmin extends User {
	static async getAll({ employerId }) {
		const [
			{
				data: { data: employeeData }
			},
			{
				data: { data: employerAdminsData }
			}
		] = await Promise.all([
			Network.AxiosWrapperV2.get({
				url: "employee"
			}),
			Network.AxiosWrapperV2.get({
				url: `employer/${employerId}/admins`
			})
		])

		const employeeDataMap = employeeData.reduce((acc, employee) => {
			acc.set(employee.id, employee)
			return acc
		}, new Map())

		const employerAdmins = new Map()

		employerAdminsData.forEach((admin) => {
			const employee = employeeDataMap.get(admin.id) || null
			if (!employee?.employment?.terminationDate)
				employerAdmins.set(
					admin.id,
					new this({
						...admin,
						employeeData: employeeDataMap.get(admin.id) || null
					})
				)
		})

		return employerAdmins
	}
}
